import { useLocalObservable } from "mobx-react";
import React, { createContext, ReactNode } from "react";
import { RxApi } from "../../api-client";
import RxTherapyStore from "./rxStore";
import RxStore from "./rxStore";
import useStore from "../../helpers/useStore";
import { AuthContext } from "../Auth/auth.provider";
import { PatientsContext } from "../Patients/patients.provider";
import { createApiConfig } from "../../api/createApiConfig";

interface RxProviderProps {
  children: ReactNode;
}

export const RxStoreContext = createContext<RxStore | null>(null);
RxStoreContext.displayName = "RxStoreContext";

export const RxStoreProvider = ({ children }: RxProviderProps) => {
  const AuthenticationStore = useStore(AuthContext);
  const patientStore = useStore(PatientsContext);
  const config = createApiConfig();
  const apiClient = new RxApi(config);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const store = useLocalObservable(() => new RxStore(apiClient, AuthenticationStore, patientStore));

  store.apiClient = apiClient;

  return <RxStoreContext.Provider value={store}>{children}</RxStoreContext.Provider>;
};
